import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CustomerAuthService } from '@pryspace/shared/api';

export const customerAuthGuard: CanActivateFn = async () => {
  const auth = inject(CustomerAuthService);
  const router = inject(Router);

  if (auth.isAuthenticated()) return true;

  const refreshed = await auth.refresh();
  if (refreshed) return true;

  await router.navigate(['/login']);
  return false;
};
